import { createPortal } from "react-dom";

import {
  Backdrop,
  ModalContainer,
  Head,
  Content,
  StyledMdClose,
} from "./BlockModal.style";

function BlockModal(props) {
  return createPortal(
    <>
      <Backdrop isShown={props.show} onClick={props.onClose}>
        <ModalContainer
          onClick={(e) => e.stopPropagation()}
          isShown={props.show}
        >
          <Head>
            <StyledMdClose fill="white" size={28} onClick={props.onClose} />
            {props.title}
          </Head>

          <Content>
            <div
              variant="p"
              component="p"
              color="primary.contrastText"
              fontSize={18}
            >
              {props.children}
            </div>
          </Content>
        </ModalContainer>
      </Backdrop>
    </>,
    document.getElementById("modal")
  );
}

export default BlockModal;
